import React, { Component } from "react";
import { Route, Redirect, Switch, withRouter } from "react-router-dom";
import LoginForm from "./components/loginForm";
import ProfileForm from "./components/profileForm";
import HowToUse from "./components/howToUse";
import About from "./components/about";
// import TermsAndConditionsForm from "./components/termsAndConditionsForm";
import Logout from "./components/logout";
import Home from "./components/home";
import NotFound from "./components/notFound";
import InstituteForm from "./components/instituteForm";
import InstituteDetails from "./components/instituteDetails";
import { getUser } from "./services/userService";

import NavBar from "./components/navBar";
// import FootBar from "./components/footBar";
import firebase from "./services/firebaseconn";
import "./App.css";
import "./services/firebaseconn";

class App extends Component {
  state = {
    loggedIn: "",
    admin: "",
    searchValue: "",
    unsubscribeUser: undefined,
  };

  handleSearchChange = (e) => {
    this.setState({ searchValue: e.target.value });
  };

  handleCleanSearch = () => {
    this.setState({ searchValue: "" });
  };

  componentDidMount() {
    const unsubscribeUser = firebase.auth().onAuthStateChanged(async (user) => {
      if (user && user.email) {
        try {
          const currentUser = await getUser(user.email);
          let admin = currentUser ? currentUser.admin : undefined;
          this.setState({ loggedIn: true, admin: admin });
        } catch (err) {
          console.log(err);
        }
      } else {
        this.setState({ loggedIn: false, admin: false });
      }
    });
    this.setState({ unsubscribeUser });
  }

  componentWillUnmount() {
    this.state.unsubscribeUser();
  }

  render() {
    const currentLocation = this.props.location.pathname;
    return (
      <React.Fragment>
        <NavBar
          loggedIn={this.state.loggedIn}
          admin={this.state.admin}
          showSearchInput={currentLocation === "/home"}
          searchValue={this.state.searchValue}
          onSearchChange={this.handleSearchChange}
          onCleanSearch={this.handleCleanSearch}
        />
        <main className="container">
          <Switch>
            <Route
              path="/home"
              render={(props) => (
                <Home {...props} searchValue={this.state.searchValue} />
              )}
            />
            <Route path="/howToUse" component={HowToUse} />
            <Route path="/about" component={About} />
            {/* <Route
              path="/termsAndConditions"
              component={TermsAndConditionsForm}
            /> */}
            <Route path="/login" component={LoginForm} />
            <Route path="/logout" component={Logout} />
            <Route
              path="/profile"
              render={(props) => <ProfileForm {...props} />}
            />
            <Route
              path="/institutes/form/:id"
              render={(props) => <InstituteForm {...props} />}
            />

            <Route
              path="/institutes/details/:id"
              render={(props) => <InstituteDetails {...props} />}
            />

            <Route path="/not-found" component={NotFound} />
            <Redirect exact from="/" to="/home" />
            <Redirect to="/not-found" />
          </Switch>
        </main>
        {/* <FootBar /> */}
      </React.Fragment>
    );
  }
}

export default withRouter(App);
// export default App;
